import AppConstants from '../../config/app.constants';

let StorageFactory = function () {
    let set = (key, value) => {
        localStorage.setItem(key, value)
    };

    let get = (key) => {
        return localStorage.getItem(key)
    }

    let remove = (key) => {
        localStorage.removeItem(key)
    }
    let clear = () => {
        localStorage.clear()
    }

    return {
        set,
        get,
        remove,
        clear
    }
};

export default StorageFactory;


// WEBPACK FOOTER //
// ./client/app/common/storage/storage.factory.js